// extracted by mini-css-extract-plugin
module.exports = {"page__header":"page-header_page__header__1qXqx"};